import api from "./api";

const VehicleTypeService = {
  getAll: async (pageNumber = 1, noOfRows = 20) => {
  const res = await api.get(
    `/vehicleType/getAll?pageNumber=${pageNumber}&noOfRows=${noOfRows}`
  );
  return res.data.data || res.data;
},


  getById: async (id) => {
    const res = await api.get(`/vehicleType/getById/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post("/vehicleType/save", data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/vehicleType/update/${id}`, data);
    return res.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/vehicleType/${id}`);
    return res.data;
  },

  toggleStatus: async (id) => {
    const res = await api.put(`/vehicleType/updateStatus/${id}`);
    return res.data;
  },


  getByVehicleType: async (vehicleType) => {
    const res = await api.get(`/vehicleType/byType/${vehicleType}`);
    return res.data;
  },

  getActive: async () => {
    const res = await api.get("/vehicleType/getActive");
    return res.data;
  },

  getActiveVehicleTypes: async () => {
    const res = await api.get("/vehicleType/getActive");
    return res.data;
  },


};

export default VehicleTypeService;
